import { c as _c } from "react/compiler-runtime";
import type { FootprintVariant } from '@onefootprint/footprint-js-legacy';
import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import type React from 'react';
import useResizeObserver from 'use-resize-observer';
import { LEGACY_IDV_CONTAINER_ID as LAYOUT_CONTAINER_ID } from '@/idv2/components/constants';
import Content from './components/content';
import FullHeightContainer from './components/full-height-container';
import { LayoutOptionsProvider, useLayoutOptions } from './components/layout-options-provider';
import type { Options as LayoutOptions } from './types';
export const BIFROST_CONTAINER_ID = 'bifrost-container-id';
export type LayoutProps = {
  variant?: FootprintVariant;
  children: React.ReactNode;
  options?: LayoutOptions;
  isSandbox?: boolean;
  isHosted?: boolean;
  fitContent?: boolean;
  onClose?: () => void;
  config?: OnboardingSessionConfig;
  navigationPortalId?: string;
};
type LayoutBodyProps = Pick<LayoutProps, 'variant' | 'children' | 'options' | 'isSandbox' | 'isHosted' | 'fitContent' | 'config'>;
const LayoutBody = t0 => {
  const $ = _c(21);
  const {
    children,
    variant,
    options: t1,
    isSandbox,
    isHosted,
    fitContent,
    config
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const options = t2;
  const {
    body: t3
  } = useLayoutOptions();
  const {
    options: t4
  } = t3;
  const {
    fullBleed
  } = t4;
  const isFitContent = variant === "inline" && !!fitContent && !fullBleed;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      box: "border-box"
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const {
    ref: headerRef,
    height: t6
  } = useResizeObserver(t5);
  const headerHeight = t6 === undefined ? 0 : t6;
  const t7 = !!options.hasDesktopBorderRadius;
  const t8 = `calc(${headerHeight}px + 2rem)`;
  let t9;
  if ($[3] !== t8) {
    t9 = {
      scrollPaddingTop: t8
    };
    $[3] = t8;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  let t10;
  if ($[5] !== children || $[6] !== config || $[7] !== headerRef || $[8] !== isFitContent || $[9] !== isHosted || $[10] !== isSandbox || $[11] !== variant) {
    t10 = <Content variant={variant} isSandbox={isSandbox} isHosted={isHosted} config={config} fitContent={isFitContent} headerRef={headerRef}>{children}</Content>;
    $[5] = children;
    $[6] = config;
    $[7] = headerRef;
    $[8] = isFitContent;
    $[9] = isHosted;
    $[10] = isSandbox;
    $[11] = variant;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== fullBleed || $[14] !== isFitContent || $[15] !== isSandbox || $[16] !== t10 || $[17] !== t7 || $[18] !== t9 || $[19] !== variant) {
    t11 = <FullHeightContainer variant={variant} id={LAYOUT_CONTAINER_ID} hasBorderRadius={t7} isSandbox={isSandbox} fitContent={isFitContent} fullBleed={fullBleed} style={t9}>{t10}</FullHeightContainer>;
    $[13] = fullBleed;
    $[14] = isFitContent;
    $[15] = isSandbox;
    $[16] = t10;
    $[17] = t7;
    $[18] = t9;
    $[19] = variant;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};
const Layout = t0 => {
  const $ = _c(18);
  const {
    children,
    variant,
    options: t1,
    isSandbox,
    isHosted,
    fitContent,
    onClose,
    config,
    navigationPortalId
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const options = t2;
  const t3 = variant === "inline";
  let t4;
  if ($[2] !== options || $[3] !== t3) {
    t4 = {
      ...options,
      hideHeaderButton: t3
    };
    $[2] = options;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== config || $[7] !== fitContent || $[8] !== isHosted || $[9] !== isSandbox || $[10] !== options || $[11] !== variant) {
    t5 = <LayoutBody variant={variant} options={options} isSandbox={isSandbox} isHosted={isHosted} fitContent={fitContent} config={config}>{children}</LayoutBody>;
    $[5] = children;
    $[6] = config;
    $[7] = fitContent;
    $[8] = isHosted;
    $[9] = isSandbox;
    $[10] = options;
    $[11] = variant;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== navigationPortalId || $[14] !== onClose || $[15] !== t4 || $[16] !== t5) {
    t6 = <LayoutOptionsProvider options={t4} onClose={onClose} navigationPortalId={navigationPortalId}>{t5}</LayoutOptionsProvider>;
    $[13] = navigationPortalId;
    $[14] = onClose;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default Layout;